import React from 'react';
import { useSitecoreContext } from 'lib/hooks/useSitecoreContext';
import SEO from './SEO';
import SiteSpecificOrganizationSchema from './SEO/SiteSpecificOrganizationSchema'; //BTFE Organization Schema change
import { ISeoData } from 'lib/seo/interfaces';
import { useSiteSettings } from 'lib/hooks/useSiteSettings';
import { useGlobalData } from 'lib/hooks/sitecore/useGlobalData'; //BTFE Organization Schema change
import { Data } from '@generated/Foundation.GMI.model';

const Metadata = () => {
  const siteSettings = useSiteSettings();
  const { siteName } = useGlobalData(); //BTFE Organization Schema change
  const seoSettings = siteSettings?.seoSettings as Data.Settings.SeoSettings;

  const { seoMetaData } = useSitecoreContext().sitecoreContext;

  return (
    <>
      <SiteSpecificOrganizationSchema siteName={siteName} seoSettings={seoSettings} />
      {seoMetaData && (
        <SEO
          seoData={seoMetaData as ISeoData}
          logoImgSrc={siteSettings?.siteLogo?.value?.src ?? ''}
          logoImgAlt={(siteSettings?.siteLogo?.value?.alt as string) ?? ''}
          favicons={{
            // TODO: See if we need separate fields for each favicon type
            icoIconSrc: siteSettings?.favIcon?.value?.src ?? '',
            svgIconSrc: siteSettings?.favIcon?.value?.src ?? '',
            appleIconSrc: siteSettings?.favIcon?.value?.src ?? '',
            androidIconSrc: siteSettings?.favIcon?.value?.src ?? '',
          }}
        />
      )}
    </>
  );
};

export default Metadata;
